/**
 * Utility functions for working with GraphQL Connection pattern
 */
/**
 * Flattens a GraphQL Connection by extracting nodes from edges.
 * Deduplicates by id to handle Apollo cache edge cases after navigation.
 * @param connection - The GraphQL connection object
 * @returns Array of unique nodes (filters out null/undefined and duplicates)
 */
export function flattenConnection(connection) {
    const nodes = connection?.edges?.map(edge => edge.node).filter((node) => node != null) || [];
    const seen = new Set();
    return nodes.filter(node => {
        if (seen.has(node.id))
            return false;
        seen.add(node.id);
        return true;
    });
}
//# sourceMappingURL=graphql-connection.js.map